





import Vue from 'vue';
export default Vue.extend({
  props: {
    currentIndex: Number,
    filteredCount: Number,
    totalCount: Number,
    hasMore: Boolean,
  },
});
